// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__eetQz","search":"Settings_search__20bCB","filter":"Settings_filter__215ny"};